export const CLEAR_PAYER_USER_ID = 'CLEAR_PAYER_USER_ID';

export const clearPayerUserId = () => ({
  type: CLEAR_PAYER_USER_ID
});
